module.exports = __webpack_public_path__ + "img/show_tc_text_3.e51cb032.png";